import React, { useState } from 'react'
import { checkInputs } from '../checkInputs'
import VerificationMail from './VerificationMail'
import { DataEntreprise } from '../interface/dataEntreprise'

const Compte = ({ dataCompte }: { dataCompte: DataEntreprise }): JSX.Element => {
    let [page, setPage] = useState<JSX.Element>(
        <div className="inscription" id="compte">
            <h1>Account</h1>

            <p>Complete the account manager information</p>

            <div id="infos">
                <input type="text" name="nom" placeholder="Name" required />
                <input type="text" name="prenom" placeholder="Surname" required />
                <input type="text" name="mail" placeholder="Email address" required />
                <input type="text" name="mdp" placeholder="Password" required />
            </div>

            <button onClick={ () => {
                if (checkInputs()) {
                    dataCompte.nomCompte = (document.getElementsByName("nom")[0] as HTMLInputElement).value
                    dataCompte.prenom = (document.getElementsByName("prenom")[0] as HTMLInputElement).value
                    dataCompte.mail = (document.getElementsByName("mail")[0] as HTMLInputElement).value
                    dataCompte.mdp = (document.getElementsByName("mdp")[0] as HTMLInputElement).value
                    setPage(<VerificationMail dataCompte={ dataCompte }/>) 
                }
            } }>Confirm</button>
        </div>
    )
    
    return page
}

export default Compte